export default {
  removalOrderPage: {
    url: '/removal/order/page',
    method: 'post',
    desc: '移除订单分页'
  },
  orderReturnsPage: {
    url: '/order/returns/page',
    method: 'post',
    desc: '退货报表分页'
  },
  getOrderList: {
    url: '/order/getOrderList',
    method: 'post',
    desc: '获取订单列表接口-简版'
  },
  getOrderDetail: { // 废弃
    url: '/order/getOrderDetail',
    method: 'post',
    desc: '获取订单详情接口'
  },
  addOrderRemark: {
    url: '/order/saveOrderRemark',
    method: 'post',
    desc: '添加订单备注接口'
  },
  saveOrderTags: {
    url: '/order/saveOrderTags',
    method: 'post',
    desc: '保存订单标记'
  },
  getAmazonOrderList: {
    url: '/order/getAmazonOrderList',
    method: 'post',
    desc: '获取亚马逊订单列表-精版'
  },
  getAmazonOrderDetail: {
    url: '/order/getAmazonOrderDetail',
    method: 'post',
    desc: '获取亚马逊订单详情接口-新'
  },
}
